import React from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api from "@/lib/api";
import { Flame } from "lucide-react";

const OPP_STATUSES = ["draft", "payment_required", "paid_pending_review", "published", "expired", "refused"];
const FR = { draft: "Brouillon", payment_required: "Paiement requis", paid_pending_review: "Payé · à vérifier", published: "Publié", expired: "Expiré", refused: "Refusé" };

export default function OpportunitiesManager() {
  const qc = useQueryClient();
  const { data: opps = [] } = useQuery({ queryKey: ["adminOpps"], queryFn: async () => (await api.get("/admin/opportunities")).data });

  const setStatus = async (id, status) => {
    try { await api.put(`/admin/opportunities/${id}`, { status }); toast.success("Statut mis à jour"); qc.invalidateQueries({ queryKey: ["adminOpps"] }); qc.invalidateQueries({ queryKey: ["opportunities"] }); }
    catch { toast.error("Erreur"); }
  };

  return (
    <section className="mt-16" data-testid="opportunities-manager">
      <h2 className="font-serif text-2xl text-stone-100 mb-6 flex items-center gap-2"><Flame className="w-5 h-5 text-amber-500" /> Appels à participation ({opps.length})</h2>
      {opps.length === 0 ? <p className="text-stone-500 text-sm" data-testid="opps-admin-empty">Aucun appel à participation.</p> : (
        <div className="space-y-2" data-testid="opps-admin-list">
          {opps.map((o) => (
            <div key={o.id} data-testid={`opp-admin-${o.id}`} className="flex flex-wrap items-center gap-3 bg-[#121418] border border-[#272A34] rounded-lg p-3">
              <span className="font-serif text-stone-100 flex-1 min-w-0 truncate">{o.title} <span className="text-xs text-stone-500">· {o.organization} · {o.city}</span></span>
              <span className={`px-2 py-0.5 rounded text-[10px] font-mono uppercase border ${o.status === "published" ? "bg-emerald-950/40 text-emerald-300 border-emerald-800/40" : o.status === "paid_pending_review" ? "bg-amber-950/40 text-amber-300 border-amber-800/40" : "bg-[#181A20] text-stone-400 border-[#272A34]"}`}>{FR[o.status] || o.status}</span>
              <select data-testid={`opp-status-${o.id}`} value={o.status} onChange={(e) => setStatus(o.id, e.target.value)} className="bg-[#0B0C0E] border border-[#272A34] rounded-md px-3 py-1.5 text-sm text-stone-200 outline-none">
                {OPP_STATUSES.map((s) => <option key={s} value={s}>{FR[s]}</option>)}
              </select>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
